import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_URL ?? ''

export const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
})

// Attach JWT from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwt')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// On 401 — clear expired token and reload. Only reload if there was a token (expired session),
// not during the initial auth request — that would create an infinite reload loop.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const hadToken = !!localStorage.getItem('jwt')
      localStorage.removeItem('jwt')
      if (hadToken) window.location.reload()
    }
    return Promise.reject(err)
  },
)
